import React from 'react';
import Select from 'react-select';
import cx from 'classnames';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

// Be sure to include styles at some point, probably during your bootstrapping
import 'react-select/dist/react-select.css';
import css from './styles.less';



class SelectDropDown extends React.Component {

    state = {
        menuOuterStyle: { transition: 'all 250ms ease', transformOrigin: 'top', transform: 'scaleY(0)' }
    }

    extraOptionProps = {
        className: css.selectOption
    }

    handleOnChange = (selected) => {
        if (!selected) return;

        const { onChange } = this.props;
        onChange && onChange(selected);
    }

    filterOption = (option) => {
        if (option.optionType === 'Region') {
            if (typeof option.label !== 'string' || option.label.trim().length == 0)
                return false;
        }
        return true;
    }

    renderOption = (option) => {
        let spaces = '';
        switch (option.optionType) {
            case 'Hotel':
                return (<div>
                    {option.label}
                </div>);
            case 'City':
                return (<div className={cx(css.boldedOption)}>
                    {option.label}
                </div>);
            case 'Region':
                return (<div className={cx(css.boldedOption)}>
                    {'- ' + option.label}
                </div>);
            default:
                return <div> </div>
        }
    }

    scaleUp = () => {
        this.setState(prev => ({
            menuOuterStyle: {
                ...prev.menuOuterStyle,
                transform: 'scaleY(1)'
            }
        }))
    }

    scaleDown = () => {
        this.setState(prev => ({
            menuOuterStyle: {
                ...prev.menuOuterStyle,
                transform: 'scaleY(0)'
            }
        }))
    }


    render() {
        const { placeholder, notValid, options, selectedOption } = this.props;

        // we use state in order to inject extra properties to the options,
        // props are owned by their parent hence they are readonly!
        const mappedOptions = options.map(o => ({ ...o, ...this.extraOptionProps }));
        const selectedValue = selectedOption && selectedOption.value;

        const { menuOuterStyle } = this.state;
        return (
            <Select
                {...this.props}
                className={cx(css.selectDropdown, css.forXs, notValid && css.notValid, "sbox__select-dropdown")}
                name="form-field-name"
                value={selectedValue}
                resetValue="..."
                placeholder={placeholder}
                options={mappedOptions}
                onChange={this.handleOnChange}
                clearable={false}
                backspaceRemoves={false}
                deleteRemoves={false}
                optionRenderer={this.renderOption}
                filterOption={this.filterOption}
                menuContainerStyle={menuOuterStyle}
                onOpen={this.scaleUp}
                onClose={this.scaleDown}
                searchable={false}
            />
        );
    }

}


SelectDropDown.defaultProps = {
    options: [
        {
            value: "item1",
            label: "item 1",
            extraProp: "item",
            className: css.selectOption
        },
        {
            value: "item2",
            label: "item 2",
            extraProp: "item",
            className: css.selectOption
        },
        {
            value: "item3",
            label: "item 3",
            extraProp: "item",
            className: css.selectOption
        }
    ]
}

export default SelectDropDown;


// WEBPACK FOOTER //
// ./src/components/SelectDropDown/SelectDropDown.js